
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3c1e54bd&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ringcontentkeyword.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ringcontentkeyword.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3c1e54bd!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ringcontentkeyword.vue"),
  /* scopeId */
  "data-v-3c1e54bd",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/system/ringcontentkeyword.vue
// module id = 1611
// module chunks = 3